import { createModule } from 'saga-slice';
import {
  fetchArchiveProjectsSagaFactory,
  unArchiveProjectSagaFactory,
  deleteArchivedProjectSagaFactory,
} from './sagas';
import { ArchiveState, initialState } from './stateType';

const ArchiveSlice = createModule({
  name: 'archive',
  initialState,
  reducers: {
    fetchProjects: (state: ArchiveState) => {
      state.loading = true;
    },
    fetchProjectsSuccess: (state: ArchiveState, payload) => {
      state.projects = payload;
      state.loading = false;
    },
    fetchProjectsError: (state: ArchiveState, payload) => {
      state.error = payload;
      state.loading = false;
    },
    unArchiveProject: (state: ArchiveState) => {
      state.loading = true;
    },
    unArchiveProjectSuccess: (state: ArchiveState, payload) => {
      state.projects = state.projects.filter(
        (project) => !payload.includes(project.id),
      );
      state.loading = false;
    },
    unArchiveProjectError: (state: ArchiveState, payload) => {
      state.error = payload;
      state.loading = false;
    },
    deleteProject: (state: ArchiveState) => {
      state.loading = true;
    },
    deleteProjectSuccess: (state: ArchiveState, payload) => {
      state.projects = state.projects.filter(
        (project) => !payload.includes(project.id),
      );
      state.loading = false;
    },
    deleteProjectError: (state: ArchiveState, payload) => {
      state.error = payload;
      state.loading = false;
    },
  },
  sagas: (actions) => ({
    [actions.fetchProjects]: fetchArchiveProjectsSagaFactory(actions),
    [actions.unArchiveProject]: unArchiveProjectSagaFactory(actions),
    [actions.deleteProject]: deleteArchivedProjectSagaFactory(actions),
  }),
});
export default ArchiveSlice;
export const archiveActions = ArchiveSlice.actions;
